// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import {EnvironmentalVars} from './environment.model';
const appSettings = window[EnvironmentalVars.APPSETTINGS];
const keycloakConfig: any = {
  url: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_URL] : "",
  realm: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_REALM] : "",
  clientId: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_CLIENT] : "",
};
const appVersion = require('../../package.json').version;
export const environment = {
  production: false,
  target: appSettings ? appSettings[EnvironmentalVars.TARGET] : "",
  buildEnv: appSettings ? appSettings[EnvironmentalVars.BUILD_ENV] : "",
  use_current_url: true,
  base_url: appSettings ? appSettings[EnvironmentalVars.BASE_URL] : "",
  rest_suffix: 'fs-online-invoicing-ws/rest/v1/',
  supportServicePrefix: appSettings ? appSettings[EnvironmentalVars.SUPPORT_SERVICE_PREFIX] : "",
  roleCheck: 'fs-online-invoicing',
  keycloak: keycloakConfig,
  auth_logout: 'https://fsconnect-test.mclaneco.com/auth/realms/FS-Connect/protocol/openid-connect/logout',
  servicePrefix: appSettings ? appSettings[EnvironmentalVars.SERVICE_PREFIX] : "",
  version: appVersion,
  localhostDev: false,
  onBaseUser: appSettings ? appSettings[EnvironmentalVars.ONBASEUSER] : "",
  onBaseURL: appSettings ? appSettings[EnvironmentalVars.ONBASEURL] : "",
  onBaseInvoices: appSettings ? appSettings[EnvironmentalVars.ONBASEINVOICES] : "",
  onBaseParents: appSettings ? appSettings[EnvironmentalVars.ONBASEPARENTS] : ""
};
